<template>
    <div></div>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";

const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "dateit",
    applicationCategory: "Event Planning Application",
    operatingSystem: "iOS, Android, Web",
    offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
    },
    description: "Create and manage events for free with dateit. Send SMS invites, share photos, and chat with guests. Perfect for weddings, parties, BBQs, and more.",
    aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.8",
        ratingCount: "1000",
    },
    featureList: ["Unlimited free event creation", "SMS invitations", "Shared photo albums", "Event chat and discussions", "Push notifications", "Cross-platform support"],
};

onMounted(() => {
    const script = document.createElement("script");
    script.setAttribute("type", "application/ld+json");
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);
});
</script> 